export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10114.5ab8cb4e.jpg";